<div class="js-alarm-group m-b-10 filter-settings">
	<div class="row p-b-10">
		<div class="col-sm-12">
			<button id="h-alarm-refresh" class="btn btn-default pull-right js-alarm-list-refresh">
				<i class="fa fa-refresh"></i>
			</button>
			<h4 class="page-title">{{TR "Alarmmeldungen"}}</h4>
		</div>
	</div>
	<div class="row">
		<div class="col-lg-12">
			<div id="h-alarm-overview" class="card-box clearfix">
				<div class="row">
					<div class="col-lg-4 col-md-6">
						<div class="row m-t-10">
							<div class="col-xs-12">
								<label class="control-label">{{TR "Gruppieren nach"}}</label>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								{{#SELECT config.group}}
								<select class="selectpicker" id="alarm-group" name="alarm-group" data-style="btn-white btn-sm">
								{{#each groupSettings}}
									<option value="{{key}}">{{text}}</option>
								{{/each}}
								</select>
								{{/SELECT}}
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="row m-t-10">
							<div class="col-xs-12">
								<label class="control-label">{{TR "Quittierung"}}</label>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<div class="dropdown-wrapper">
									{{#SELECT filter.ackValue}}
									<select class="selectpicker js-alarm-filter" multiple="multiple" id="alarm-acknowledge" name="alarm-acknowledge" data-empty="{{TR "alles anzeigen"}}" data-style="btn-white btn-sm">
										<option value="1">{{TR "Quittiert"}}</option>
										<option value="0">{{TR "Nicht quittiert"}}</option>
									</select>
									{{/SELECT}}
								</div>
							</div>
						</div>
					</div>
					<div class="col-lg-4 col-md-6">
						<div class="row m-t-10">
							<div class="col-xs-12">
								<label class="control-label">{{TR "Alarmzustand"}}</label>
							</div>
						</div>
						<div class="row">
							<div class="col-xs-12">
								<div class="dropdown-wrapper">
									{{#SELECT filter.triggeredValue}}
									<select class="selectpicker js-alarm-filter" multiple="multiple" id="alarm-triggered" name="alarm-triggered" data-empty="{{TR "alles anzeigen"}}" data-style="btn-white btn-sm">
										<option value="0">{{TR "Alarm dauert an"}}</option>
										<option value="1">{{TR "Alarm behoben"}}</option>
									</select>
									{{/SELECT}}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

{{{emptyView}}}

{{#each groups}}
<div class="js-alarm-group m-b-10 filter-settings">
	<div class="row p-b-10">
    	<div class="col-xs-12">
        	<h4 class="page-title">{{name}}</h4>
    	</div>
	</div>
	<div class="row">
    	<div class="col-xs-12" id="{{region}}">
    	</div>
	</div>
</div>
{{/each}}
